/*
 * @function: 监听页面状态
 * https://cooper.didichuxing.com/knowledge/share/page/hQPLUXpIQaEp#页面《mpx项目实现onshow以及onhide的功能》
 */
const SHOW = 'show';
const HIDDEN = 'hidden';
// 动画间隔
// 在Web开发中，当你在页面上使用setTimeout设置定时器时，定时器的行为可能受到页面的可见性状态（visibility state）的影响。
// 这是因为现代浏览器为了优化性能，会降低在后台标签页上运行的定时器的执行频率，以减少资源消耗。
// 具体而言，当页面不可见（例如，用户切换到另一个标签页或最小化浏览器窗口）时，浏览器可能会将定时器的执行间隔增加到一个较大的值，
// 以减少在后台运行时的资源使用。而当页面重新变为可见状态时，定时器的执行间隔又会被还原为原始设置。
// 如果低电量模式，系统会降频，间隔时间也是变大
const HIDDEN_INTERVAL = 600;
var pageType;
(function (pageType) {
    pageType["SHOW"] = "show";
    pageType["HIDDEN"] = "hidden";
})(pageType || (pageType = {}));
let pageVisibilityStatus = SHOW;
function getPageStatus(cb) {
    document.addEventListener('visibilitychange', () => {
        if (document.hidden && pageVisibilityStatus === SHOW) {
            cb(HIDDEN);
        }
        else if (!document.hidden && pageVisibilityStatus === HIDDEN) {
            cb(SHOW);
        }
    });
    window.addEventListener('pagehide', () => {
        if (pageVisibilityStatus === HIDDEN)
            return;
        cb(HIDDEN);
    });
    window.addEventListener('pageshow', () => {
        if (pageVisibilityStatus === SHOW)
            return;
        cb(SHOW);
    });
}
class AnimationFrame {
    constructor() {
        this.startTime = 0;
        this.callback = null;
        this.timer = null;
    }
    // requestAnimationFrame轮询，如果页面不可见，requestAnimationFrame会暂停，页面可见后会继续轮询
    moveAnimation() {
        this.startTime = Date.now();
        if (pageVisibilityStatus === HIDDEN) {
            // 如果判断之前已经Show了，说明visibilitychange或者pageshow触发了show，就不需要轮询来判断了
            this.callback(SHOW);
            this.pollingStartTime();
        }
        window.requestAnimationFrame(this.moveAnimation.bind(this));
    }
    // 使用setInterval对startTime进行轮询，如果页面不可见，startTime不会更新，大于HIDDEN_INTERVAL，说明页面不可见了
    pollingStartTime() {
        const now = Date.now();
        const interval = now - this.startTime;
        if (!this.timer) {
            this.updateTimer();
        }
        if (pageVisibilityStatus === HIDDEN) {
            // 在轮询判断是否hidden之前，已经hidden了，关闭动画
            this.clearTimer();
        }
        else if (interval > HIDDEN_INTERVAL && pageVisibilityStatus === SHOW) {
            this.callback(HIDDEN);
            this.clearTimer();
        }
    }
    updateTimer() {
        this.timer = setInterval(() => {
            this.pollingStartTime();
        }, HIDDEN_INTERVAL);
    }
    clearTimer() {
        this.timer && clearInterval(this.timer);
        this.timer = null;
    }
    startAnimation(cb) {
        if (this.startTime)
            return;
        if (cb) {
            this.callback = cb;
        }
        this.moveAnimation();
        this.pollingStartTime();
    }
}
class PageClass {
    constructor() {
        this.router = null;
        this.rootPath = '';
        this.currentPath = '';
        this.showListenerMap = {};
        this.hideListenerMap = {};
        this.animation = new AnimationFrame();
        this.init();
    }
    initSpaRouter(fn) {
        if (!this.router) {
            setTimeout(() => {
                this.initSpaRouter(fn);
            }, 50);
            return;
        }
        this.router.beforeEach(async (to, from, next) => {
            const toPath = to.path.slice(1);
            const fromPath = from.path.slice(1);
            await next();
            fn && fn(toPath, fromPath);
        });
    }
    getCurrentPath() {
        if (!this.router)
            return 'index';
        const currentRoute = this.router.currentRoute;
        const path = currentRoute.path || currentRoute.value.path;
        return path.slice(1);
    }
    checkoutPageFunction() {
        return 'onvisibilitychange' in document
            && 'onpageshow' in window
            && 'onpagehide' in window;
    }
    useRouter(router) {
        this.router = router;
        this.initSpaRouter(this.pathChange.bind(this));
    }
    init() {
        getPageStatus(this.listenCallback.bind(this));
        if (!this.checkoutPageFunction()) {
            this.animation.startAnimation(this.listenCallback.bind(this));
        }
    }
    initPath() {
        this.currentPath = this.getCurrentPath();
        this.rootPath = this.currentPath;
    }
    initRootPath() {
        if (!this.rootPath) {
            this.initPath();
        }
    }
    pathChange(toPath, fromPath) {
        this.currentPath = toPath;
        if (toPath === fromPath)
            return;
        this.onHideCallBack(fromPath);
        this.onShowCallBack(toPath);
        this.clearPathListener(fromPath);
    }
    onShowCallBack(path) {
        const cbs = this.showListenerMap[path] || [];
        if (!cbs.length)
            return;
        const list = cbs.slice();
        for (let index = 0; index < list.length; index++) {
            const fn = list[index];
            fn();
        }
    }
    onHideCallBack(path) {
        const cbs = this.hideListenerMap[path] || [];
        if (!cbs.length)
            return;
        const list = cbs.slice();
        for (let index = 0; index < list.length; index++) {
            const fn = list[index];
            fn();
        }
    }
    listenCallback(type) {
        // 统一拦截 如果已经回调了，后续状态没有变更，不会再发起回调
        if (pageVisibilityStatus === type)
            return;
        pageVisibilityStatus = type;
        const path = this.getCurrentPath();
        if (type === HIDDEN) {
            this.onHideCallBack(path);
        }
        else {
            this.onShowCallBack(path);
        }
    }
    pageShow(fn) {
        if (!fn)
            return;
        this.initRootPath();
        const path = this.getCurrentPath();
        if (!this.showListenerMap[path]) {
            this.showListenerMap[path] = [];
        }
        this.showListenerMap[path].push(fn);
    }
    pageHide(fn) {
        if (!fn)
            return;
        this.initRootPath();
        const path = this.getCurrentPath();
        if (!this.hideListenerMap[path]) {
            this.hideListenerMap[path] = [];
        }
        this.hideListenerMap[path].push(fn);
    }
    clearPathListener(fromPath) {
        if (fromPath !== this.rootPath) {
            this.hideListenerMap[fromPath] = [];
            this.showListenerMap[fromPath] = [];
        }
    }
    remove(fn, type, path) {
        const map = type === HIDDEN ? this.hideListenerMap : this.showListenerMap;
        const listenerList = map[path] || [];
        let length = listenerList.length;
        while (length--) {
            const cb = listenerList[length];
            if (cb === fn) {
                listenerList.splice(length, 1);
            }
        }
    }
    onPageShowOnce(fn) {
        let fired = false;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        function magic() {
            const path = that.getCurrentPath();
            that.remove(magic, pageType.SHOW, path);
            if (!fired) {
                fired = true;
                fn();
            }
        }
        this.pageShow(magic);
    }
    onPageHideOnce(fn) {
        let fired = false;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        function magic() {
            const path = that.getCurrentPath();
            that.remove(magic, pageType.HIDDEN, path);
            if (!fired) {
                fired = true;
                fn();
            }
        }
        this.pageHide(magic);
    }
}
const page = new PageClass();
export const useRouter = page.useRouter.bind(page);
export const onPageShow = page.pageShow.bind(page);
export const onPageHide = page.pageHide.bind(page);
export const onPageShowOnce = page.onPageShowOnce.bind(page);
export const onPageHideOnce = page.onPageHideOnce.bind(page);
